"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  dFlex: {
    display: "flex"
  },
  selectBox: {
    position: "relative"
  },
  selectBoxCurrent: function selectBoxCurrent(props) {
    return {
      border: "1px solid ".concat(props.invalidFeedback ? _variables.colors.fire : _variables.colors.hare, " "),
      position: "relative",
      borderRadius: "10px",
      boxShadow: "none",
      width: "100%",
      fontFamily: "IranSansX",
      color: _variables.colors.night,
      fontSize: "14px",
      lineHeight: "24px",
      textAlign: "right",
      direction: "rtl",
      outline: "none",
      backgroundColor: _variables.colors.ghost,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer"
    };
  },
  disabled: {
    borderColor: _variables.colors.whale,
    color: _variables.colors.whale
  },
  selectBoxIcon: {
    height: "16px",
    marginBottom: "0px",
    marginLeft: "25px",
    transform: "rotate(90deg)"
  },
  selectBoxInputText: {
    fontFamily: "IranSansX",
    fontSize: "18px",
    color: _variables.colors.night,
    marginRight: "23px",
    display: "flex",
    flexFlow: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%"
  },
  option: {
    fontWeight: "normal",
    display: "block",
    whiteSpace: "pre",
    minHeight: "2.2em",
    padding: [0, 2, 1]
  },
  selectBoxInput: {
    display: "none"
  },
  selectBoxSearch: {
    position: "relative"
  },
  selectBoxSearchIcon: {
    position: "absolute",
    right: "24px",
    top: "30%"
  },
  selectBoxSearchInput: function selectBoxSearchInput(props) {
    return {
      backgroundColor: _variables.colors.swan,
      border: "none",
      width: "100%",
      borderRadius: "10px 10px 0 0",
      height: props.size === "xs" ? "38px" : "56px",
      textIndent: "59px",
      fontFamily: "IranSansX",
      fontSize: props.size === "xs" ? "12px" : "14px",
      color: _variables.colors.wolf
    };
  },
  selectBoxList: function selectBoxList(props) {
    return {
      border: "1px solid ".concat(_variables.colors.hare, " "),
      borderRadius: "10px",
      direction: "rtl",
      marginTop: "10px",
      backgroundColor: _variables.colors.ghost,
      position: "absolute",
      zIndex: "1000",
      width: "100%",
      display: "none",
      overflowY: "auto",
      maxHeight: props.size === "xs" ? "35vh" : "50vh",
      minHeight: "40px"
    };
  },
  selectBoxOption: function selectBoxOption(props) {
    return {
      padding: props.size === "xs" ? [10, 20, 10, 0] : [12, 23, 12, 0],
      fontFamily: "IranSansX",
      fontWeight: props.size === "xs" && "100",
      fontSize: props.size === "xs" ? "12px" : "18px",
      color: _variables.colors.night,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: _variables.colors.hare,
        "&:first-child": {
          borderRadius: "10px 10px 0 0"
        },
        "&:last-child": {
          borderRadius: "0 0 10px 10px"
        }
      }
    };
  },
  md: {
    minWidth: "140px",
    minHeight: "60px",
    fontSize: "14px"
  },
  sm: {
    minWidth: "110px",
    minHeight: "48px",
    fontSize: "12px"
  },
  xs: {
    minWidth: "110px",
    minHeight: "38px",
    fontSize: "12px",
    fontWeight: "100"
  },
  invalidFeedback: {
    fontFamily: "IranSansX",
    width: "100%",
    marginTop: "6px",
    lineHeight: "13px",
    direction: "rtl",
    textAlign: "right",
    marginRight: "23px",
    color: _variables.colors.fire
  },
  errTxtSm: {
    fontSize: "10px"
  },
  errTxtXs: {
    fontSize: "12px"
  },
  errTxtMd: {
    fontSize: "14px"
  },
  none: {
    display: "none !important"
  },
  block: {
    display: "block !important"
  },
  selectedItem: {
    backgroundColor: _variables.colors.hare,
    "&:first-child": {
      borderRadius: "10px 10px 0 0"
    },
    "&:last-child": {
      borderRadius: "0 0 10px 10px"
    }
  },
  selectListItems: {
    whiteSpace: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    lineStyle: "none",
    display: "flex",
    flexFlow: "row-reverse",
    width: "80%"
  },
  selectList: {
    backgroundColor: _variables.colors.swan,
    color: _variables.colors.night,
    borderRadius: "10px",
    display: "inline-block"
  },
  selectListXs: {
    margin: "7px",
    padding: "0px 10px",
    fontSize: "12px",
    fontWeight: '100'
  },
  selectListSm: function selectListSm(props) {
    return {
      margin: props.select ? "7px" : "0",
      padding: "7px 20px",
      fontSize: "12px"
    };
  },
  selectListMd: function selectListMd(props) {
    return {
      margin: props.select ? "10px" : "0",
      padding: "10px 30px",
      fontSize: "14px"
    };
  },
  itemsSizeXs: {
    fontSize: "14px",
    fontWeight: "100"
  },
  itemsSizeSm: {
    fontSize: "14px"
  },
  itemsSizeMd: {
    fontSize: "16px"
  },
  itemsDescription: {
    wordWrap: "break-word",
    maxWidth: "300px"
  },
  itemsDescriptionSizeXs: {
    fontSize: "12px",
    fontWeight: "100"
  },
  itemsDescriptionSizeSm: {
    fontSize: "12px"
  },
  itemsDescriptionSizeMd: {
    fontSize: "14px"
  },
  singleSelectListItems: {
    direction: "ltr",
    width: "100%",
    whiteSpace: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    lineStyle: "none",
    display: "flex",
    flexFlow: "row-reverse"
  },
  singleSelectedLabel: {
    color: "rgb(114, 114, 114)",
    "float": "right",
    right: "10px",
    zIndex: "1",
    position: "absolute",
    // visibility: "hidden",
    fontFamily: "IranSansX",
    lineHeight: "1px",
    paddingLeft: "10px",
    paddingRight: "10px",
    textTransform: "capitalize",
    backgroundColor: "rgb(255, 255, 255)",
    top: "-1px"
  },
  dropdownLoading: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '100',
    backdropFilter: 'blur(3px)',
    backgroundColor: 'rgba(0,0,0,0.1)',
    minHeight: '40px'
  },
  errColor: {
    color: "".concat(_variables.colors.fire, " !important")
  }
}), {
  name: 'pds-dropdown'
});
exports.useStyles = useStyles;